import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Actions } from 'src/app/service/menu-service/menu.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-trip-actions-dropdown',
  templateUrl: './trip-actions-dropdown.component.html',
  styleUrls: ['./trip-actions-dropdown.component.css']
})
export class TripActionsDropdownComponent implements OnInit {
  @Input() trip:any;
  @Input() user:any;

  @Output() edit = new EventEmitter<any>();
  @Output() detail = new EventEmitter<any>();
  @Output() completedDetail = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  @Output() willCall = new EventEmitter<any>();
  @Output() confirmIntake = new EventEmitter<any>();
  @Output() unConfirmIntake = new EventEmitter<any>();
  @Output() placePatient = new EventEmitter<any>();

  Actions = Actions;
  hasPermissions;
  allowPlacement = false;

  constructor(
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.setPermissions();
    if (this.user && this.user.allowPlacement) {
      this.allowPlacement = this.user.allowPlacement;
    }
  }

  setPermissions() {
    this.sharedDataService
      .getPermissions()
      .subscribe((permissions) => {
        this.hasPermissions = permissions;
      });
  }
}
